'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SelectInputTag = function (_Component) {
  _inherits(SelectInputTag, _Component);

  function SelectInputTag() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SelectInputTag);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SelectInputTag.__proto__ || Object.getPrototypeOf(SelectInputTag)).call.apply(_ref, [this].concat(args))), _this), _this.handleRemove = function (event) {
      var _this$props = _this.props,
          onRemove = _this$props.onRemove,
          option = _this$props.option;

      event.preventDefault();
      event.stopPropagation();
      onRemove(option);
    }, _this.getClassName = function () {
      var _this$props2 = _this.props,
          option = _this$props2.option,
          stylingKey = _this$props2.stylingKey;

      var className = 'SelectedInputTag ';
      return stylingKey ? className + option[stylingKey] : className;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SelectInputTag, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          displayKey = _props.displayKey,
          option = _props.option;

      return _react2.default.createElement(
        'li',
        { className: this.getClassName() },
        _react2.default.createElement(
          'button',
          { className: 'SelectedInputTag-close', onClick: this.handleRemove },
          _react2.default.createElement(
            'svg',
            {
              xmlns: 'http://www.w3.org/2000/svg',
              className: 'SelectedInputTag-close-icon',
              viewBox: '0 0 13 13'
            },
            _react2.default.createElement('path', { d: 'M12.712.298a.982.982 0 0 0-1.39 0L6.5 5.11 1.679.288a.982.982 0 1 0-1.39 1.39L5.108 6.5.29 11.321a.982.982 0 1 0 1.39 1.39L6.5 7.892l4.821 4.82a.982.982 0 1 0 1.39-1.39L7.892 6.5l4.82-4.821a.988.988 0 0 0 0-1.38z' })
          )
        ),
        _react2.default.createElement(
          'span',
          { className: 'SelectedInputTag-text' },
          option[displayKey]
        )
      );
    }
  }]);

  return SelectInputTag;
}(_react.Component);

SelectInputTag.propTypes = {
  displayKey: _propTypes2.default.string.isRequired,
  stylingKey: _propTypes2.default.string,
  option: _propTypes2.default.object.isRequired
};

exports.default = SelectInputTag;


//////////////////
// WEBPACK FOOTER
// ../frontend-component-library/build/Components/FormInputs/Select/SelectInputTag.js
// module id = 545
// module chunks = 0